import classes from "./Section2.module.css";

// Import images
import partner1 from "./partners/1.webp";
import partner2 from "./partners/2.webp";
import partner3 from "./partners/3.webp";
import partner4 from "./partners/4.webp";
import partner5 from "./partners/5.webp";
import partner6 from "./partners/6.webp";
import partner7 from "./partners/7.webp";
import partner8 from "./partners/8.webp";
import partner9 from "./partners/9.webp";
import partner10 from "./partners/10.webp";

const partners = [
  // partner1,
  partner2,
  partner3,
  partner4,
  partner5,
  partner6,
  partner7,
  partner8,
  partner9,
  partner10,
];

export default function Section2() {
  return (
    <div className={classes.partnersGrid}>
      {partners.map((partner, index) => (
        <div key={index} className={classes.partnerItem}>
          <img
            src={partner}
            alt={`Partner ${index + 1}`}
            className={classes.partnerImage}
          />
        </div>
      ))}
    </div>
  );
}
